import {Component, OnInit} from '@angular/core';
import {PermissionsService} from "../../services/permissions/permissions.service";
import {Router} from "@angular/router";
import {SharedService} from "../../services/shared/shared.service";
import Constants from "../../shared/constants";

@Component({
    selector: 'xlog-user-logged-in',
    templateUrl: './user-logged-in.component.pug',
    styleUrls: ['./user-logged-in.component.scss'],
    standalone: false
})
export class UserLoggedInComponent implements OnInit {
    email: string;
    firstName: string;
    lastName: string;
    uuid: string;
    textVerifyValuePassword = '';
    inputType = '';
    token = '';
    model: any;

    constructor(
        private featureFlagService: PermissionsService,
        private router: Router,
        private sharedService: SharedService) {
        const ffOn = this.featureFlagService.isFeatureActivated('ent-10781-signup-improvements');
        if (ffOn) {
            const stored = localStorage.getItem('signupUserData');
            const state = stored ? JSON.parse(stored) : null;
            if (state?.email && state?.uuid) {
                this.email = state.email;
                this.firstName = state.firstName || '';
                this.lastName = state.lastName || '';
                this.uuid = state.uuid;
                this.token = state.token;
            }
        } else {
            const navigation = this.router.getCurrentNavigation();
            if (navigation?.extras.state) {
                const state = navigation.extras.state as any;
                this.email = state.email;
                this.firstName = state.firstName;
                this.lastName = state.lastName;
                this.uuid = state.uuid;
                this.token = state.token;
            }
        }
    }

    ngOnInit() {
        // Component Library V2.0 does not support Wrap text in Tertiary Buttons,
        // so used this method to force Wrap text, text-align right and set specific width of button
        setTimeout(() => {
            const tertiaryButton = document.querySelector('.tertiary-button');
            tertiaryButton.classList.add('wrap-text');
        });
    }

    redirectionTermsAndCondition() {
        window.open(Constants.SIGNUP_TERMS_XREF_URL, "_blank");
    }

    redirectionToSignup() {
        window.location.href = '/signup';
    }

    onSubmit() {
        localStorage.setItem('previousUrl', '/user-logged-in');
        if (this.featureFlagService.isFeatureActivated('ent-10781-signup-improvements')) {
            localStorage.removeItem('signupUserData');
        }
        this.sharedService.setUserData({email: this.email, token: this.token});
        this.router.navigate(['/org-creation']);

    }
}
